import { useState, useEffect } from 'react'
import SnackBar from 'material-ui/Snackbar'
import ConsoleIcon from 'material-ui/svg-icons/hardware/device-hub'

import Filtro from 'components/filters/filter-labeled-family'
import Message from 'components/message'
import HeaderIcon from 'components/header-icon'
import DeleteFamily from 'components/delete-dialog'
import ButtonNewItem from 'components/button-new-item'

import IconEmpty from 'images/iconEmpty.icon'

import Fetch from 'utils/fetch'
import StorePersist from 'utils/store-persist'

import LabeledFamilyList from './list'
import LabeledFamilyForm from './form'
import './labeled-family.css'

import intl from 'react-intl-universal'
import { profileAdminOrMasterData } from "services/permissions/getPermissions";
import { IconFilterActive } from 'components/icons/icn-filter-active.icon'
import { IconFilterInactive } from 'components/icons/icn-filter-inactive.icon'
import { generateQueryParams } from 'utils/custom-functions'
import { formatErrorMessage } from 'utils/handle-error';
import Sidebar from 'components/sidebar'
import ButtonIcon from 'components/button-icon'
import { useBudgetFamilyContext } from '../context'

const LabeledFamily = () => {
  const { startFetching, stopFetching } = useBudgetFamilyContext();
  const [labeledFamilies, setLabeledFamilies] = useState([])
  const [total, setTotal] = useState(0)
  const [openDelete, setOpenDelete] = useState(false)
  const [currentPage, setCurrentPage] = useState(0)
  const [openForm, setOpenForm] = useState(false)
  const [openEditMode, setOpenEditMode] = useState(false)
  const [idSelected, setIdSelected] = useState(0)
  const [showFeedback, setShowFeedback] = useState(false)
  const [messageFeedBack, setMessageFeedBack] = useState('')
  const [qtRegsPerPage] = useState(50)
  const [showMsg, setShowMsg] = useState(false)
  const [textMsg, setTextMsg] = useState('')
  const [showFilter, setShowFilter] = useState(false)
  const [filters, setFilters] = useState(() => StorePersist.getValuesJSON('filtersLabeledFamily') ?? 
    {
      IdCarteira: null,
      IdFamilia: null,
      IdFamiliaRotulada: null
    }
  );

  useEffect(() => {
    searchFamilies()
  }, [])

  const showMessage = (message) => {
    setShowMsg(true)
    setTextMsg(message)
  }

  const showFeedbackMessage = (message) => {
    setShowFeedback(true)
    setMessageFeedBack(message)
  }

  const closeFeedback = () => {
    setShowFeedback(false)
  }

  const handleOpenForm = () => {
    setOpenForm(true)
  }

  const openNewForm = () => {
    setOpenEditMode(false)
    handleOpenForm()
  }

  const openEditForm = (row) => {
    const selected = labeledFamilies[row]
    setOpenEditMode(true)
    setIdSelected(selected.Id)
    handleOpenForm()
  }

  const closeForm = () => {
    setOpenForm(false)
  }

  const handleOpenDelete = (id) => {
    setOpenDelete(true)
    setIdSelected(id)
  }

  const proccessErro = (ex) => {
    stopFetching()
    showMessage((ex.response?.status === 400) ? formatErrorMessage(ex) : intl.get('stocks.timeline.feedback.serverError'))
  }

  const refreshSearch = () => {
    closeForm()
    searchFamilies()
  }

  const proccessData = (data) => {
    setLabeledFamilies(data.Data)
    setTotal(data.TotalRecordCount)
  }

  const closeDelete = () => {
    setOpenDelete(false)
  }

  const deleteFamily = () => {
    Fetch.delete(`/labeled-families/${idSelected}`)
      .then(closeDelete)
      .then(searchFamilies)
      .then(() => showFeedbackMessage(intl.get('master-data.walletsAndFamilys.labeledFamily.feedback.labeledFamilySuccessfullyDeleted')))
      .catch((e) => proccessErro(e))
  }

  const searchFamilies = (page = 0, filter = filters) => {
    startFetching()
    const nextPage = page == undefined ? currentPage : page
    const _body = {
      MaterialGroupId: filter.IdCarteira > 0 ? filter.IdCarteira : null,
      FamilyId: filter.IdFamilia > 0 ? filter.IdFamilia : null,
      LabeledFamilyId: filter.IdFamiliaRotulada > 0 ? filter.IdFamiliaRotulada : null,
      _page: nextPage,
      _size: qtRegsPerPage
    }

    Fetch.get(`/labeled-families:paginated?${generateQueryParams(_body)}`)
      .then((response) => proccessData(response.data))
      .then(() => stopFetching())
      .then(() => setCurrentPage(nextPage))
      .catch((e) => proccessErro(e))
  }

  const toggleFilter = () => {
    setShowFilter(prevState => !prevState)
  }

  const verifyFilter = () => {
    return filters.IdCarteira > 0
      || filters.IdFamilia > 0
      || filters.IdFamiliaRotulada > 0
  }

  const searchFilters = (newFilters) => {
    StorePersist.setValuesJSON('filtersLabeledFamily', newFilters)
    toggleFilter()
    setCurrentPage(0)
    setFilters(newFilters)
    searchFamilies(0, newFilters)
  }

  return (
    <div className='labeled-family-container'>
      <div className="labeled-family-header">
        <HeaderIcon
          title={intl.get('master-data.walletsAndFamilys.labeledFamily.header.title')}
          subtitle={intl.get('master-data.walletsAndFamilys.labeledFamily.header.subtitle')}
          icon={<ConsoleIcon style={{ width: 45, height: 45 }} color='var(--color-brand-500)' />}
        >

          {profileAdminOrMasterData() &&
            <div title={intl.get('master-data.walletsAndFamilys.labeledFamily.actions.newLabeledFamily')} >
              <ButtonNewItem
                className="general-button"
                onClick={openNewForm}
              />
            </div>
          }
          <div title={intl.get('master-data.walletsAndFamilys.labeledFamily.actions.filter')} className='filterContainer'>
            <ButtonIcon
              onClick={toggleFilter}
              buttonType='default'
              buttonText={intl.get('filters.filter')}
              buttonIcon={verifyFilter() ? <IconFilterActive /> : <IconFilterInactive />}
              className={"button-filter"}
            />
          </div>
        </HeaderIcon>
      </div>

      <LabeledFamilyList
        data={labeledFamilies}
        countData={total}
        refreshSearch={searchFamilies}
        handleEdit={openEditForm}
        handleDelete={handleOpenDelete}
        qtRegsPerPage={qtRegsPerPage}
        profileAdminOrMasterData={profileAdminOrMasterData()}
        currentPage={currentPage}
      />

      {openForm &&
        <LabeledFamilyForm
          idEdit={idSelected}
          open={openForm}
          editMode={openEditMode}
          handleClose={closeForm}
          handleRefresh={refreshSearch}
          handleFeedback={showFeedbackMessage}
          profileAdminOrMasterData={profileAdminOrMasterData()}
        />
      }

      <DeleteFamily
        open={openDelete}
        title={intl.get('master-data.walletsAndFamilys.labeledFamily.deleteModal.title')}
        handleClose={closeDelete}
        warningMessage={intl.get('master-data.general.materials.description')}
        handleConfirm={deleteFamily}
      />

      <SnackBar
        message={messageFeedBack}
        open={showFeedback}
        autoHideDuration={3000}
        onRequestClose={closeFeedback}
      />

      <Message
        show={showMsg}
        text={textMsg}
        title={intl.get('commons.errorTitle')}
        handleClose={() => setShowMsg(false)}
      />

      <Sidebar
        visible={showFilter}
        triggerClose={toggleFilter}
        icon={<IconEmpty />}
      >
        <Filtro
          initialData={filters}
          showFilter={showFilter}
          handleClose={searchFilters}
        />
      </Sidebar>
    </div>
  )
}

export default LabeledFamily
